/**
 * 默认配置
 */
const configData: IConfig = {
	/** aegis配置 */
	aegisData: {
		id: 'RBhLTrkqwVYTuTeNOE', // 项目ID，即上报id
		uin: '', // 用户唯一 ID（可选）
		reportApiSpeed: true, // 接口测速
		reportAssetSpeed: true, // 静态资源测速
		pagePerformance: true, // 开启页面测速
		onError: true, // 进行错误监听，获取错误日志
		spa: true, // SPA
		api: {
			apiDetail: true,
			reportRequest: true
		} // api全量上报
	},

	/** !important 供应商不需要-使用不延迟登录模式 */
	useUnDelayMode: false,

	/** 自定义登录入API */
	useLocalCustomAuthUrl: '/api/v1/users/test',

	/** 自定义退出登录URL */
	useLocalCustomLogoutUrl: '/mock-api/v1/users/logout',

	/** 真实服务退出登录URL(右上角点击退出的那个跳转地址) */
	useLocalCustomRealLogoutUrl: '/api/logout',

	/**
	 * 当前语言环境
	 *
	 * @type {string}
	 * @memberof ConfigDefault
	 */
	locale: '',

	/** i18n对象 */
	i18n: {},

	/**
	 * 当前环境
	 *
	 * @type {string}
	 * @memberof ConfigDefault
	 */
	env: '',

	/**
	 * 当前访问路由地址
	 *
	 * @type {string}
	 * @memberof ConfigDefault
	 */
	httpUrl: '',

	/**
	 * 接口请求列表域名
	 *
	 * @type {IChannel}
	 * @memberof ConfigDefault
	 */
	channel: {
		default: {
			url: 'https://cnodejs.org/'
		}
	},

	/**
	 * XSS配置
	 *
	 * @type {*}
	 * @memberof ConfigDefault
	 */
	xssConfig: {
		// 在这里增加其他白名单 tag
		font: ['face', 'color', 'style', 'size', 'class', 'id'],
		img: ['id', 'src', 'class', 'width', 'height', 'style'],
		i: ['id', 'class', 'width', 'height', 'style'],
		span: ['id', 'class', 'width', 'height', 'style']
	},

	/**
	 * 显示日志
	 *
	 * @type {boolean}
	 * @memberof ConfigDefault
	 */
	isDisplayLogs: true,

	/** 本地访问的中转地址 */
	devHost: 'http://127.0.0.1',

	/** 本地服务地址 */
	mockHost: 'http://127.0.0.1',

	/** dev server port */
	devServerPort: 8180,

	/** mock server port */
	mockServerPort: 8190,

	/** 当前请求默认频道 */
	defaultChannel: '/api',

	/** 代理配置 */
	proxyTable: {
		'/umaterial': {
			target: 'http://127.0.0.1:8090',
			changeOrigin: true,
			pathRewrite: {
				'^/umaterial': '/'
			}
		},
		'/ubuy': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true,
			pathRewrite: {
				'^/ubuy': '/'
			}
		},
		'/pages': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/logout': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/login': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/order': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		},
		'/material': {
			target: 'http://127.0.0.1:8080',
			changeOrigin: true
		}
	},
	hideHeaderLanguageFlag: true
};

export default configData;

/**
 * iconfig
 * @export
 * @interface IConfig
 */
export interface IConfig {
	aegisData?: any;

	/** 自定义退出登录URL */
	useLocalCustomLogoutUrl?: string;

	/** 真实服务退出登录URL */
	useLocalCustomRealLogoutUrl?: string;

	/** 使用不延迟登录模式 */
	useUnDelayMode?: boolean;

	/** 自定义登录入API */
	useLocalCustomAuthUrl?: string;
	useStandardLogin?: boolean;
	isDisplayLogs: boolean;
	proxyTable: IProxyData;
	devServerPort?: number;
	mockServerPort?: number;
	locale?: any;
	env?: any;
	httpUrl?: any;
	channel?: any;
	xssConfig?: any;
	i18n?: any;
	devHost?: string;
	mockHost?: string;
	defaultChannel?: string;
	/** 隐藏头部的CurrentLanguage */
	hideHeaderLanguageFlag?: boolean;
}

/**
 * proxy data
 * @export
 * @interface IProxyData
 */
export interface IProxyData {
	'/umaterial': IProxyItem;
	'/ubuy': IProxyItem;
	'/pages': IProxyItem;
	'/logout': IProxyItem;
	'/login': IProxyItem;
	// bfc新接口
	'/require'?: IProxyItem;
	'/order'?: IProxyItem;
	'/acceptance'?: IProxyItem;
	'/bill'?: IProxyItem;
	'/material'?: IProxyItem;
	'/decision'?: IProxyItem;
	'/price'?: IProxyItem;
	'/common-data'?: IProxyItem;
	'/supplier'?: IProxyItem;
}

/**
 * proxy item
 *
 * @export
 * @interface IProxyItem
 */
export interface IProxyItem {
	target: string;
	changeOrigin?: true;
	pathRewrite?: any;
	realService?: any;
}
